import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';

let styles;
const ARROW_ASSET = require('./arrow.svg');
const CLOSE_ASSET = require('./close.svg');

export default class JumboSelect extends Component {
  constructor(props) {
    super(props);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.clear = this.props.clear.bind(this);
    this.assignClasses = this.assignClasses.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  assignClasses() {
    this.selectClasses = [
      styles.select,
      this.state.isOpen ? styles.select_open : null,
    ];

    this.panelClasses = [
      styles.panel,
      this.state.isOpen ? styles.panel_open : null,
      this.props.modifier === 'breeds' ? styles.panel_breeds : null,
      this.props.modifier === 'needs' ? styles.panel_needs : null,
      this.props.modifier === 'interests' ? styles.panel_interests : null,
    ];

    this.iconClasses = [
      styles.select_icon,
      this.state.isOpen || this.props.selected > 0 ? styles.select_icon_open : null,
    ];

    this.arrowClasses = [
      styles.select_arrow,
      this.state.isOpen ? styles.select_arrow_open : null,
    ];

    this.labelClasses = [
      !this.props.selected && !this.state.isOpen ? styles.select_placeholder : null,
    ];
  }

  render() {
    this.assignClasses();

    return (
      <div>
        <div className={css(styles.select_container)}>
          <div
            role="button"
            tabIndex={0}
            className={css(this.selectClasses)}
            onClick={this.toggleOpen}
          >
            <span className={css(this.labelClasses)}>
              {this.props.defaultAll && !this.props.selected ? 'All ' : null} {this.props.label} {this.props.selected ? ` (${this.props.selected})` : null}
            </span>
            {this.props.selected !== 0 ?
              <span
                className={css(styles.clear_container)}
                title="Clear value"
                aria-label="Clear value"
                onClick={this.clear}
                role="button"
                tabIndex="0">
                <span className={css(styles.button)}>×</span>
              </span>
            : ''}
          </div>
          <Isvg cacheGetRequests src={this.props.icon} className={css(this.iconClasses)} />
          <Isvg cacheGetRequests src={ARROW_ASSET} className={css(this.arrowClasses)} />

        </div>
        <div className={css(this.panelClasses)}>
          {Theme.isMobile ?
            <div
              role="button"
              tabIndex={0}
              className={this.state.isOpen ? css(styles.select_close) : null}
              onClick={this.toggleOpen}
            /> : null
          }
          {Theme.isMobile ?
            <h4 className={css(styles.heading)}>{this.props.label}</h4>
          : null}
          {this.props.children}
        </div>
        {!Theme.isMobile ?
          <div
            role="button"
            tabIndex={0}
            className={this.state.isOpen ? css(styles.select_close) : null}
            onClick={this.toggleOpen}
          /> : null
        }
      </div>
    );
  }
}

JumboSelect.defaultProps = {
  defaultAll: false,
  modifier: null,
  selected: 0,
};

JumboSelect.propTypes = {
  defaultAll: PropTypes.bool,
  modifier: PropTypes.string,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  selected: PropTypes.number,
  clear: PropTypes.func, //eslint-disable-line
};

styles = StyleSheet.create({
  select_container: {
    position: 'relative',
    zIndex: 2,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  heading: {
    marginTop: 30,
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  select: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 180,
    padding: '0 50px',
    fontFamily: Theme.font_family_primary,
    fontSize: 15,
    color: '#000e1f',
    border: '1px solid #e4e4e4',
    borderRadius: 3,
    backgroundColor: Theme.white,
    appearance: 'none',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 300ms',

    [Theme.mobile_query]: {
      width: '100%',
    },

    ':hover': {
      boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
    },
  },
  select_open: {
    color: Theme.white,
    backgroundColor: '#031a37',
  },
  select_close: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 4,
    height: '100vh',
    width: '100vw',
    content: '""',

    [Theme.mobile_query]: {
      position: 'absolute',
      top: 15,
      right: 15,
      left: 'auto',
      zIndex: 6,
      height: 20,
      width: 20,
      backgroundImage: `url('${CLOSE_ASSET}')`,
      backgroundSize: 'cover',
    },
  },
  select_placeholder: {
    color: '#828282',
  },
  select_icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    height: 50,
    width: 50,
    pointerEvents: 'none',
    fill: '#D0D0D0',
    transition: 'fill 300ms',
  },
  select_icon_open: {
    fill: Theme.primary,
  },
  select_arrow: {
    position: 'absolute',
    top: 0,
    right: 20,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms',
  },
  select_arrow_open: {
    transform: 'rotateX(180deg)',
  },
  panel: {
    position: 'absolute',
    top: 80,
    left: '50%',
    zIndex: 5,
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: Theme.container_width,
    padding: '39px 0 34px',
    backgroundColor: Theme.white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.19)',
    border: 'solid 1px #e2e2e2',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'all 300ms',

    [Theme.mobile_query]: {
      position: 'absolute',
      top: -121,
      left: -15,
      height: '100vh',
      width: '100vw',
      padding: '0 5px',
      paddingBottom: 30,
      backgroundColor: Theme.white,
      flexDirection: 'column',
      flexWrap: 'initial',
      transform: 'none',
      overflow: 'scroll',
      justifyContent: 'flex-start',
    },

    ':before': {
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      height: 0,
      width: 0,
      marginLeft: -17,
      border: 'solid transparent',
      borderWidth: 17,
      borderColor: 'transparent',
      borderBottomColor: '#e2e2e2',
      pointerEvents: 'none',
      content: '""',

      [Theme.mobile_query]: {
        display: 'none',
      },
    },

    ':after': {
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      height: 0,
      width: 0,
      marginLeft: -16,
      border: 'solid transparent',
      borderWidth: 16,
      borderColor: 'transparent',
      borderBottomColor: Theme.white,
      pointerEvents: 'none',
      content: '""',

      [Theme.mobile_query]: {
        display: 'none',
      },
    },
  },
  panel_breeds: {
    ':before': {
      transform: 'translateX(-90px)',
    },
    ':after': {
      transform: 'translateX(-90px)',
    },
  },
  panel_interests: {
    ':before': {
      transform: 'translateX(145px)',
    },
    ':after': {
      transform: 'translateX(145px)',
    },
  },
  panel_needs: {
    ':before': {
      transform: 'translateX(220px)',
    },
    ':after': {
      transform: 'translateX(220px)',
    },
  },
  panel_open: {
    top: 70,
    opacity: 1,
    pointerEvents: 'initial',
  },
  clear_container: {
    animation: 'Select-animation-fadeIn 200ms',
    color: '#999',
    cursor: 'pointer',
    display: 'table-cell',
    position: 'absolute',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '17px',
    right: 36,
    transition: 'color 300ms',
    marginLeft: '77px',
    fontSize: 18,

    [Theme.mobile_query]: {
      marginLeft: '157px',
    },

    [Theme.iphone_plus_query]: {
      marginLeft: '196px',
    },
  },
  clear_button: {
    display: 'inline-block',
    fontSize: '18px',
    lineHeight: '1',
  },
});



// WEBPACK FOOTER //
// ./src/components/JumboSelect/index.js